import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

const WavingBearSVG = () => {
  return (
    <motion.svg
      width="200"
      height="200"
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Bear Body & Head */}
      <circle cx="100" cy="120" r="40" fill="#D2691E" />  {/* Body */}
      <circle cx="100" cy="70" r="30" fill="#D2691E" />   {/* Head */}

      {/* Ears */}
      <circle cx="80" cy="40" r="10" fill="#D2691E" />
      <circle cx="120" cy="40" r="10" fill="#D2691E" />

      {/* Facial Details */}
      <circle cx="90" cy="65" r="3" fill="#000000" />      {/* Left Eye */}
      <circle cx="110" cy="65" r="3" fill="#000000" />     {/* Right Eye */}
      <circle cx="100" cy="75" r="10" fill="#F4A460" />    {/* Muzzle */}
      <circle cx="100" cy="75" r="3" fill="#000000" />     {/* Nose */}

      {/* Waving Arm adjusted to wave up and down using style prop for transformBox and transformOrigin */}
      <motion.g
        style={{ transformBox: "fill-box", transformOrigin: "130px 85px" }}
        animate={{ rotate: [15, -15, 15, -15, 15] }}
        transition={{
          duration: 1.8,
          repeat: Infinity,
          repeatType: "reverse",
          ease: "easeInOut",
        }}
      >
        <path
          d="M130 90 C140 100 150 110 160 100 C160 90 150 80 140 80 Z"
          fill="#D2691E"
        />
      </motion.g>
    </motion.svg>
  );
};

function CancelPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-purple-50 to-white flex items-center justify-center p-4">
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        {/* Card with no border and no shadow */}
        <Card className="w-full max-w-md p-8 text-center space-y-6 !border-none !shadow-none">
          <motion.div
            initial={{ y: 10 }}
            animate={{ y: [0, -10, 0] }}
            transition={{ duration: 1.5, repeat: Infinity, repeatType: 'reverse' }}
            className="flex justify-center"
          >
            <WavingBearSVG />
          </motion.div>

          <div className="space-y-4">
            <h1 className="text-3xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
              Until We Meet Again! 👋
            </h1>
            <p className="text-gray-600">
              We'll keep your virtual seat warm! Remember, you're always welcome back 
              whenever you're ready to give us another try.
            </p>
          </div>

          <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
            <Link to="/">
              <Button
                className="w-full bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white shadow-lg"
                size="lg"
              >
                Back to Homepage
              </Button>
            </Link>
          </motion.div>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
            className="text-sm text-gray-500 mt-4"
          >
            P.S. Did you know? 75% of our users come back within 30 days! 🌟
          </motion.p>
        </Card>
      </motion.div>
    </div>
  );
}

export default CancelPage;